import cn from 'classnames';
import React from 'react';

interface NomadagoPathProps {
  className?: string;
}

export const NomadagoPath: React.FC<NomadagoPathProps> = ({ className }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    className={cn('text-yellow-400', className)}
    fill="none"
    viewBox="0 0 35 8"
  >
    <path
      fill="currentColor"
      d="M31.37.77A3.47 3.47 0 0 0 27.92 2a3.3 3.3 0 0 1-2.55 1.17h-2.78A3.37 3.37 0 0 1 19.94 2a3.5 3.5 0 0 0-5.48 0 3.36 3.36 0 0 1-2.65 1.18H9c-.97 0-1.9-.43-2.52-1.18a3.51 3.51 0 1 0 0 4.34 3.37 3.37 0 0 1 2.65-1.17h2.69c1.01-.03 1.99.4 2.65 1.17a3.5 3.5 0 0 0 5.48 0 3.37 3.37 0 0 1 2.65-1.17h2.68c1.01-.03 1.99.4 2.65 1.17A3.5 3.5 0 1 0 31.38.73v.03l-.01.01Z"
    />
  </svg>
);
